interface Props {
  color: string;
  size: number;
}

const VENT_CAP_COLOR = '#242424';

export function VentCap({ size }: Props) {
  return (
    <svg width={23 * size} viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle
        cx="11.4"
        cy="11.4"
        r="10.45"
        fill="white"
        stroke={VENT_CAP_COLOR}
        strokeWidth="1.1"
      />
      <circle cx="11.4" cy="11.4" r="11.2" stroke={VENT_CAP_COLOR} strokeWidth="0.4" />
      <line x1="11.4" y1="0.399994" x2="11.4" y2="22.4" stroke={VENT_CAP_COLOR} strokeWidth="2" />
      <line x1="22.4" y1="11.4" x2="0.400002" y2="11.4" stroke={VENT_CAP_COLOR} strokeWidth="2" />
      <path
        d="M18.9 13.9C13.4 14.9 11.4 11.4 11.4 11.4H22.4C22.4 11.4 21.8923 13.3559 18.9 13.9Z"
        fill={VENT_CAP_COLOR}
      />
      <path
        d="M13.9 3.89999C14.9 9.39999 11.4 11.4 11.4 11.4L11.4 0.399994C11.4 0.399994 13.3559 0.907671 13.9 3.89999Z"
        fill={VENT_CAP_COLOR}
      />
      <path
        d="M8.89969 18.9C7.89969 13.4 11.3997 11.4 11.3997 11.4L11.3997 22.4C11.3997 22.4 9.44375 21.8923 8.89969 18.9Z"
        fill={VENT_CAP_COLOR}
      />
      <path
        d="M3.9 8.89969C9.4 7.89969 11.4 11.3997 11.4 11.3997L0.400002 11.3997C0.400002 11.3997 0.907679 9.44375 3.9 8.89969Z"
        fill={VENT_CAP_COLOR}
      />
    </svg>
  );
}
